import React, { useEffect, useState } from "react";
import InsertDriveFileOutlined from "@mui/icons-material/InsertDriveFileOutlined";
import { useDropzone } from "react-dropzone";
import classes from "./index.module.scss";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { modalData, rowSelected, snackbarData, userCredentials } from "recoilState/GlobalState";
import { Button } from "components";
import { SBMDocumentoPdfIns } from "services/services-mia";

export default function FileUpload({ updateList }) {
    const [file, setFile] = useState(null);
    const [errorFile, setErrorFile] = useState(false);
    const [fileOnDrop, setFileOnDrop] = useState(false);

    const xgridRowSelected = useRecoilValue(rowSelected);
    const credentials = useRecoilValue(userCredentials);
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const setModal = useSetRecoilState(modalData);
    const setXgridRowSelected = useSetRecoilState(rowSelected);

    const onDrop = async (acceptedFiles, rejectedFiles) => {
        if (acceptedFiles[0]?.path === ".pdf") {
            return setErrorFile("El archivo debe tener un nombre");
        }
        if (rejectedFiles.length > 0) {
            if (rejectedFiles[0].errors[0].code === "file-too-large") {
                return setErrorFile("Solo se permiten archivos menores a 100 MB");
            } else {
                return setErrorFile("Solo se permiten archivos PDF.");
            }
        }
        if (acceptedFiles.length > 0) {
            setErrorFile(false);
            setFile(acceptedFiles[0]);
            setFileOnDrop(true);
        }
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        accept: { "application/pdf": [".pdf"] },
        maxSize: 100 * 1024 * 1024,
        onDrop,
    });

    function bytesToMegabytes(bytes) {
        const megabytes = bytes / (1024 * 1024);
        return megabytes < 1 ? megabytes.toFixed(1) : Math.floor(megabytes);
    }

    function fileToBase64(f) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result.split(",")[1]);
            reader.onerror = reject;
            reader.readAsDataURL(f);
        });
    }

    const sendFile = async () => {
        const base64 = await fileToBase64(file);
        const response = await SBMDocumentoPdfIns(
            {
                sbmDocumentoId: xgridRowSelected.row.id,
                sbmDocumentoPDF: base64,
                sbmDocumentoTicketsTag: null,
            },
            credentials
        );
        if (response.status.code === 1) {
            setSnackBarInfo({
                message: "Archivo cargado correctamente",
                severity: "success",
                open: true,
            });
            setModal({ isOpen: false });
            updateList();
        } else {
            setSnackBarInfo({
                message: response.status.errmsg || "Ocurrió un error al cargar el archivo",
                severity: "error",
                open: true,
            });
            setModal({ isOpen: false });
        }
    };

    const deleteFile = () => {
        setFile(null);
        setModal({ isOpen: false });
    };

    useEffect(() => {
        return () => {
            setXgridRowSelected({ status: false, row: {} });
        };
    }, [setXgridRowSelected]);

    return (
        <div>
            <div
                {...getRootProps()}
                className={`${classes.dropZone} ${isDragActive ? classes.dropZoneActive : ""}`}
            >
                <input {...getInputProps()} />
                <InsertDriveFileOutlined className={classes.dropZoneIcon} />
                <p>
                    Arrastrá el archivo o <span>buscalo</span>
                </p>
                {file && (
                    <span className={classes.fileName}>
                        {file.name} — {bytesToMegabytes(file.size)} MB
                    </span>
                )}
            </div>
            {errorFile && <span className={classes.error}>{errorFile}</span>}
            <div className={classes.containerBtn}>
                <Button
                    onClick={deleteFile}
                    text="Cancelar"
                    sx={{ borderRadius: '50em !important', fontWeight: '700 !important', minWidth: '10rem', padding: '0.6em 1.5em !important' }}
                />
                <Button
                    onClick={sendFile}
                    text="Subir"
                    disabled={!fileOnDrop}
                    sx={{ borderRadius: '50em !important', fontWeight: '700 !important', minWidth: '10rem', padding: '0.6em 1.5em !important' }}
                />
            </div>
        </div>
    );
}
